export class Dispatch {
    public name: string
    public payload: any
    constructor(name: string, payload: any) {
        this.name = name
        this.payload = payload
    }
}
